import React from "react";
import "./Footer.css";
import { Link } from "react-router-dom";
const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section about">
          <h2 className="logo-text">
            <span></span>DagaGroup
          </h2>
          <p>
            Welcome to Our Website. We provide the best solutions for all your
            needs. Stay connected with us .
          </p>
          {/* <div className="contact">
            <span>
              <i className="fas fa-phone"></i> &nbsp; 123-456-7890
            </span>
            <span>
              <i className="fas fa-envelope"></i> &nbsp; info@mywebsite.com
            </span>
          </div> */}
        </div>

        <div className="footer-section links">
          <h2>Quick Links</h2>
          <br />
          <ul>
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/about">About</Link>
            </li>
            <li>
              <Link to="/services">Services</Link>
            </li>
            <li>
              <Link to="/contact">Contact</Link>
            </li>
            <li>
              <Link to="/products">Products</Link>
            </li>
          </ul>
        </div>

        <div className="footer-section contact-form">
          <h2>Contact Us</h2>
          <br />
          <form action="#" method="post">
            <input
              type="email"
              name="email"
              className="text-input contact-input"
              placeholder="Your email address..."
            />
            <textarea
              name="message"
              className="text-input contact-input"
              placeholder="Your message..."
            ></textarea>
            <button type="submit" className="btn btn-big">
              <i className="fas fa-envelope"></i> Send
            </button>
          </form>
        </div>
      </div>

      <div className="footer-bottom">&copy; Designed by Himanshu Jangid</div>
    </footer>
  );
};

export default Footer;
